import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { usePedidos } from '../../../../contexts/Pedidos';
import { ModalDetalhePedido } from '../Modais/ModalDetalhePedido';
import { useHistory } from 'react-router-dom';
import { PaginationTable } from '../../../../themes/components/PaginationTable';
import { VscArrowSmallDown, VscArrowSmallUp } from "react-icons/vsc";
import moment from 'moment';
import { Typography } from "@material-ui/core";
import ReactLoading from 'react-loading';
import { PrePedido } from '../../interfaces';
import { useEffectOnce } from 'react-use';
import { RowListaPrePedidos } from '../RowListaPrePedidos';

const useStyles = makeStyles({
  root: {
    width: '97.6%',
    margin: '0px 1em 0px 1em',
    border: '1px #ccc solid',
  },
  container: {
    maxHeight: '65vh',
  },
});

export function TabelaListaPrePedidos() {
  const { getPrePedido } = usePedidos();
  const classes = useStyles();
  const [showModalDetalhePed, setShowModalDetalhePedido] = useState<boolean>(false);
  const [selectedPedido, SetSelectedPedido] = useState<number>(0);
  const history = useHistory();
  const [pedidosBusca, setPedidosBusca] = useState<PrePedido[]>([])
  const [loadingBuscaPedidosConsulta, setLoadingBuscaPedidosConsulta] = useState<boolean>(true);


  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [pageCount, setPageCount] = useState<number>(0);
  const handleChangePage = (event: any, value: any) => { setCurrentPage(value) };
  const [pedidosPage, setPedidosPage] = useState<PrePedido[]>([]);


  const [orderBy, setOrderBy] = useState("id");
  const [revertOrderBy, setReveterOrderBy] = useState(false);
  const [ordenedPedidos, setOrdenedPedidos] = useState<PrePedido[]>([]);

  //Buscando os pedidos na primeira vez que a tela abrir, ainda sem filtro;
  useEffectOnce(() => {
    getPrePedido(-1, history)
      .then((res: PrePedido[]) => {
        setPedidosBusca(res);
        setLoadingBuscaPedidosConsulta(false);
      })
      .catch((err: any) => {
        console.log("Erro ao buscar pré-pedidos")
        setLoadingBuscaPedidosConsulta(false);
      })
  })

  //Define a seta de ordenação que vai aparecer o lado do nome da coluna
  function showOrderByIcon(option: string) {
    switch (option) {
      case "id":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "cod_cliente":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "data_emissao":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "data_entrega":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "quantidade_total":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "valor_total":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      default:
        return <></>
    }
  }

  useEffect(() => {
    if (pedidosBusca instanceof Array)
      setOrdenedPedidos(pedidosBusca);
  }, [pedidosBusca])

  // This effect calculate the page number on filtered results
  useEffect(() => {
    if (ordenedPedidos instanceof Array)
      setPageCount(Math.ceil(ordenedPedidos.length / perPage));
  }, [perPage, ordenedPedidos]);

  // This effect apply the filtered caracters on products and set an array only with matched results
  // Whenever have change in filtered the current page is set to 0, the initial page 
  useEffect(() => {
    if (ordenedPedidos instanceof Array) {
      let tempPedidos = ordenedPedidos;

      if (revertOrderBy) {
        switch (orderBy) {
          case "id":
            tempPedidos.sort(function (a, b) {
              let keyA = a.id, keyB = b.id;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "cod_cliente":
            tempPedidos.sort(function (a, b) {
              let keyA = a.cod_cliente, keyB = b.cod_cliente;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "data_emissao":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.data_emissao, "DD/MM/YYYY");
              let keyB = moment(b.data_emissao, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "data_entrega":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.data_entrega, "DD/MM/YYYY");
              let keyB = moment(b.data_entrega, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "quantidade_total":
            tempPedidos.sort(function (a, b) {
              let keyA = a.quantidade_total, keyB = b.quantidade_total;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "valor_total":
            tempPedidos.sort(function (a, b) {
              let keyA = a.valor_total, keyB = b.valor_total;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      } else {

        switch (orderBy) {
          case "id":
            tempPedidos.sort(function (a, b) {
              let keyA = a.id, keyB = b.id;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "cod_cliente":
            tempPedidos.sort(function (a, b) {
              let keyA = a.cod_cliente, keyB = b.cod_cliente;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "data_emissao":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.data_emissao, "DD/MM/YYYY");
              let keyB = moment(b.data_emissao, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "data_entrega":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.data_entrega, "DD/MM/YYYY");
              let keyB = moment(b.data_entrega, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "quantidade_total":
            tempPedidos.sort(function (a, b) {
              let keyA = a.quantidade_total, keyB = b.quantidade_total;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "valor_total":
            tempPedidos.sort(function (a, b) {
              let keyA = a.valor_total, keyB = b.valor_total;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      }
      setCurrentPage(1);
      setOrdenedPedidos(tempPedidos);
    }
  }, [orderBy, revertOrderBy, ordenedPedidos]);


  // This effect push the filtered registers in current page
  useEffect(() => {
    if (ordenedPedidos instanceof Array) {
      let tempPedidos = [];
      let maxReg = currentPage * perPage;
      for (let index = (currentPage - 1) * perPage; index < maxReg && index < ordenedPedidos.length; index++) {
        if (ordenedPedidos[index] !== undefined)
          tempPedidos.push(ordenedPedidos[index]);
      }
      setPedidosPage(tempPedidos);
    }
  }, [ordenedPedidos, currentPage, perPage, orderBy, revertOrderBy, pedidosBusca]);

  function atualizarTabela() {
    setLoadingBuscaPedidosConsulta(true);
    getPrePedido(-1, history)
      .then((res: PrePedido[]) => {
        setPedidosBusca(res);
        setLoadingBuscaPedidosConsulta(false);
      })
      .catch((err: any) => {
        console.log("Erro ao buscar pré-pedidos")
        setLoadingBuscaPedidosConsulta(false);
      })
  }

  return (
    <>
      {loadingBuscaPedidosConsulta ? 
        <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
        :
        <>
          <TableContainer component={Paper} className={classes.root}>
            <Table stickyHeader aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("id") }}>{showOrderByIcon("id")}Id</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("cod_cliente") }} align="left">{showOrderByIcon("cod_cliente")}Cliente</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("data_emissao") }} align="center">{showOrderByIcon("data_emissao")}Data Criação</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("data_entrega") }} align="center">{showOrderByIcon("data_entrega")}Previsão Faturamento</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("quantidade_total") }} align="right">{showOrderByIcon("quantidade_total")}Quantidade Total</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("valor_total") }} align="right">{showOrderByIcon("valor_total")}Valor Total</TableCell>
                  <TableCell align="right" />
                  <TableCell align="right" />
                </TableRow>
              </TableHead>
              <TableBody>
                {pedidosPage !== null && pedidosPage instanceof Array && pedidosPage.length > 0 ? pedidosPage.map((row, index) => (
                  <RowListaPrePedidos key={row.id}
                    row={row}
                    index={index}
                    atualizarTabela={atualizarTabela}
                  />
                )) : <TableRow><TableCell><Typography>Nenhum pré-pedido encontrado.</Typography></TableCell></TableRow>}
                {pageCount > 1 && perPage - pedidosPage.length > 0 && (
                  <TableRow style={{ height: 63 * (perPage - pedidosPage.length) }} >
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <ModalDetalhePedido showModal={showModalDetalhePed} numPed={selectedPedido} codEmp={"2"} setShowModal={setShowModalDetalhePedido} />
          </TableContainer>
          <PaginationTable
            textSingle="Pré-Pedido"
            textPlural="Pré-Pedidos"
            arrayItens={ordenedPedidos}
            page={currentPage}
            countPages={pageCount}
            defaultPage={1}
            handleChange={handleChangePage}
            shape="round"
            setCurrentPage={setCurrentPage}
            setPerPage={setPerPage}
            optionsPerPage={[5, 10, 50]}
            perPage={perPage}
          />
        </>
      }
    </>
  );
}